export const moduleSlug = 'imports';
export const moduleAuth = 'Imports';
export const children = [
  {
    path: "",
    component: () => import('./pages/Transactions.vue'),
    meta: {
      title: 'Import Transactions',
      linkTitle: 'Transactions',
      linkIcon: 'credit-card',
      showInNav: true,
      permission: 'Imports.Read',
    }
  },
  {
    path: 'config/settings',
    component: () => import('@/components/Configuration/Configurations.vue'),
    props: { moduleSlug: moduleSlug },
    meta: {
      title: 'Configurations',
      linkIcon: '',
      showInNav: false,
      brandFlag: 'enableConfigurations',
      permission: "Imports.Config.Settings",
    }
  }
];

export const quickLinks = [
  {
    name: 'Settings',
    link: `/${moduleSlug}/config/settings`,
    new: true,
    brandFlag: 'enableConfigurations',
    permission: 'Imports.Config.Settings',
  }
];